module.exports = __webpack_public_path__ + "img/gray-bg.35034b11.png";